import React from "react";
import { useRouter } from 'next/router';

import classNames from "classnames";
import dynamic from 'next/dynamic';

import { makeStyles } from "@material-ui/core/styles";
import Loading from 'components/Functions/Loading';

const Footer = dynamic(() => import('/components/Footer/Footer.js'), { loading: () => <Loading /> });

import styles from "/styles/jss/bbhost/pages/landingPage.js";

// Sections for this page
import HeaderSection from "pages-sections/HeaderSection.js";

const DataCenterSection = dynamic(() => import('pages-sections/DataCenterPage-Sections/DataCenterSection.js'));
const NetworkSection = dynamic(() => import('pages-sections/DataCenterPage-Sections/NetworkSection.js'));

const GridContainer = dynamic(() => import('/components/Grid/GridContainer.js'), { loading: () => <Loading />, ssr: false });
const GridItem = dynamic(() => import('/components/Grid/GridItem.js'));
const NavPills = dynamic(() => import('/components/NavPills/NavPills.js'));

import { Business, Cloud } from '@material-ui/icons';

import { trans } from "lang/lang.js";

const useStyles = makeStyles(styles);

const SEO = {
  title: "BB Host - Infraestrutura",
  description: "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a operação.",
  url: "https://www.bbhost.com.br/infrastructure",
  type: "website",
  languageAlternates: [
    {
        hrefLang: 'en',
        href: "https://www.bbhost.com.br/en/infrastructure",
    },
    {
        hrefLang: 'es',
        href: "https://www.bbhost.com.br/es/infrastructure",
    }
  ],
};

const TabIndex = {
  0: "datacenter",
  1: "network",
};

function getIndex(name = null)
{
  switch(name)
  {
    case "network":
      return 1;
    case "datacenter":
    default:
      return 0;
    
  }
}

export default function Infrastructure(props) {
  const classes = useStyles();
  let { query } = useRouter();  
  
  const tabs = [
    {
      tabButton: trans('infrastructure::tabs.datacenter'),
      tabIcon: Business,
      tabContent: (<DataCenterSection />)
    },
    {
      tabButton: trans('infrastructure::tabs.network'),
      tabIcon: Cloud,
      tabContent: (<NetworkSection />)
    }
  ];

  const activeIndex = getIndex(query.index);

  if(query.index != undefined && ['network', 'datacenter'].includes(query.index))
  {
    SEO.url += `https://www.bbhost.com.br/infrastructure/${query.index}`;
    SEO.languageAlternates[0].href = `https://www.bbhost.com.br/en/infrastructure/${query.index}`;
    SEO.languageAlternates[1].href = `https://www.bbhost.com.br/es/infrastructure/${query.index}`;
  }

  return (
    <div>
      <HeaderSection name="infrastructure" seo={SEO} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <div className={classes.section}>
            <GridContainer justifyContent="center">
              <GridItem xs={12} sm={12} md={12}>
                <NavPills
                  color="info"
                  alignCenter
                  tabs={tabs}
                  active={activeIndex}
                  tabIndex={TabIndex}
                />
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export async function getStaticProps({ req, res }) {
  return {
    props: { }
  }
}